import { HistoryResponse } from '../types';

export class ApiService {
  private baseUrl: string;

  constructor(baseUrl: string = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000') {
    this.baseUrl = baseUrl;
  }

  async getHistory(sessionId: string): Promise<HistoryResponse> {
    const response = await fetch(`${this.baseUrl}/api/history/${sessionId}`);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  async getSessions() {
    const response = await fetch(`${this.baseUrl}/api/sessions`);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  async deleteSession(sessionId: string) {
    const response = await fetch(`${this.baseUrl}/api/session/${sessionId}`, {
      method: 'DELETE'
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  async healthCheck() {
    const response = await fetch(`${this.baseUrl}/health`);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}